/* eslint-disable func-names */
export const jobApplicationForm = () => {
    const inputCv = document.getElementById('cvupload');
    const cvShow = document.querySelector('.js-cv-show');
    const inputMotivatie = document.getElementById('motivatiebrief');
    const motivatieShow = document.querySelector('.js-motivatie-show');
    const inputGenerated1 = document.getElementById('input-generated-1');
    const generated1Show = document.querySelector('.js-generated-1-show');
    const inputGenerated2 = document.getElementById('input-generated-2');
    const generated2Show = document.querySelector('.js-generated-2-show');
    const inputGenerated3 = document.getElementById('input-generated-3');
    const generated3Show = document.querySelector('.js-generated-3-show');
    const inputGenerated4 = document.getElementById('input-generated-4');
    const generated4Show = document.querySelector('.js-generated-4-show');

    function changeFile(upload, show) {
        upload.onchange = function () {
            if (this.files[0].size > 4194304) {
                // 4 MB
                this.value = '';
                upload.classList.add('error-uploading');
            } else {
                upload.classList.remove('error-uploading');
            }
        };

        // eslint-disable-next-line no-use-before-define
        upload.addEventListener('change', showFileName);

        function showFileName() {
            // console.log('changed');
            // const uploadItem = event.srcElement;

            if (upload.files[0]) {
                const fileName = upload.files[0].name;

                show.textContent = `File name: ${fileName}`;
            } else {
                show.textContent = '';
            }
        }
    }
    if (inputCv && cvShow) {
        changeFile(inputCv, cvShow);
    }
    if (inputMotivatie && motivatieShow) {
        changeFile(inputMotivatie, motivatieShow);
    }
    if (inputGenerated1 && generated1Show) {
        changeFile(inputGenerated1, generated1Show);
    }
    if (inputGenerated2 && generated2Show) {
        changeFile(inputGenerated2, generated2Show);
    }
    if (inputGenerated3 && generated3Show) {
        changeFile(inputGenerated3, generated3Show);
    }
    if (inputGenerated4 && generated4Show) {
        changeFile(inputGenerated4, generated4Show);
    }

    const FloatLabel = (() => {
        // add active class
        const handleFocus = (e) => {
            const { target } = e;
            target.parentNode.classList.add('active');
            target.setAttribute(
                'placeholder',
                target.getAttribute('data-placeholder')
            );
        };

        // remove active class
        const handleBlur = (e) => {
            const { target } = e;
            if (!target.value) {
                target.parentNode.classList.remove('active');
            }
            target.removeAttribute('placeholder');
        };

        // register events
        const bindEvents = (element) => {
            const floatField =
                element.querySelector('input') ||
                element.querySelector('textarea');
            if (floatField) {
                floatField.addEventListener('focus', handleFocus);
                floatField.addEventListener('blur', handleBlur);
            }
        };

        // get DOM elements
        const init = () => {
            const floatContainers =
                document.querySelectorAll('.float-container');

            floatContainers.forEach((element) => {
                if (
                    element.querySelector('input') &&
                    element.querySelector('input').value
                ) {
                    element.classList.add('active');
                }
                if (
                    element.querySelector('textarea') &&
                    element.querySelector('textarea').value
                ) {
                    element.classList.add('active');
                }

                bindEvents(element);
            });
        };

        return {
            init,
        };
    })();

    FloatLabel.init();
};
